/**
 * Trigger Form Button Click
 */
$('.js-trigger-add-to-cart').on('click', function(event) {
  console.log($('.js-main-pdp form input[type="submit"], .js-main-pdp form button[type="submit"]'))
  $('.js-main-pdp form input[type="submit"], .js-main-pdp form button[type="submit"]').trigger('click');

  event.preventDefault();
});
